import { CustomerTabs } from "pages/backoffice/Customer/List/types";

export const ApiUrls = {
	tenants: {
		getList: "/tenants",
		getTenantDetails: (id: string) => `/tenants/${id}`,
		create: "/tenants",
		edit: (id: string) => `/tenants/${id}`
	},
	terms: {
		getList: "terms",
		getLatestList: "terms/latest",
		getAvailableTermTypes: "terms/term-types/available",
		create: "terms",
		updateDate: (id: string) => `/terms/${id}/update-date`,
		getById: (id: string) => `/terms/${id}`,
		cancelTerm: (id: string) => `/terms/${id}`
	},
	tenantType: {
		getList: "/tenant-types"
	},
	partners: {
		getList: "/partners",
		getPartnerDetails: (id: string) => `/partners/${id}`,
		category: {
			getList: "partner-categories"
		}
	},
	customers: {
		getList: (tab: CustomerTabs) => `/customers/${tab}`,
		getCustomerDetails: (id: string) => `/customers/${id}`
	}
};
